var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgReject = function SvgReject(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none!important",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16zm3.131 11.131a.993.993 0 0 1-1.417 0l-1.508-1.52a.309.309 0 0 0-.412 0l-1.508 1.52a1.005 1.005 0 0 1-1.417 0 .972.972 0 0 1-.298-.708.995.995 0 0 1 .298-.709l1.52-1.508a.309.309 0 0 0 0-.412l-1.52-1.508a1.006 1.006 0 0 1 1.417-1.417l1.508 1.52a.309.309 0 0 0 .412 0l1.508-1.52a1.005 1.005 0 1 1 1.417 1.417l-1.52 1.508a.309.309 0 0 0 0 .412l1.52 1.508a.994.994 0 0 1 0 1.417z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgReject);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "reject.b7b01a319144170c7b93548253a43760.svg";